import { Component, effect, Inject } from '@angular/core';
import { IonApp, IonRouterOutlet, Platform } from '@ionic/angular/standalone';
import { DokaApp, DokaContent, DokaFooter, DokaFooterInfo, DokaFooterLink, DokaHeader, DokaUserContextMenu, DokaUserContextMenuEntry, PlatformService, VcrDirective, CoreService, PlatformType, DokaLanguageContextMenu } from '@doka/angular-core';
import { I18NextEagerPipe, I18NextService, ITranslationService } from 'angular-i18next';
import { environment } from 'src/environments/environment';
import { DokaI18NextService } from '@doka/i18next';
import { FilterService } from './shared/services/filter.service';
import { Router } from '@angular/router';
import { DokaIdentityLoginService } from '@doka/identity-login';
import { UsersClient } from 'src/api/services/generated/api-clients';
import { UserInfoService } from './shared/services/user-info.service';
import { SidebarComponent, SidebarEntry } from './shared/components/sidebar/sidebar.component';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [
    IonApp,
    IonRouterOutlet,
    I18NextEagerPipe,
    DokaHeader,
    DokaUserContextMenu,
    DokaUserContextMenuEntry,
    DokaApp,
    DokaContent,
    VcrDirective,
    DokaFooter,
    DokaFooterLink,
    DokaFooterInfo,
    SidebarComponent,
    DokaLanguageContextMenu
],
})
export class AppComponent {
  public environment = environment;

  protected readonly sidebarEntries: SidebarEntry[] = [
    {
      route: '/my-tasks',
      icon: 'dashboard',
      label: 'Sidebar.MyTasks',
      exact: false,
    },
    {
      route: '/plan',
      icon: 'money',
      label: 'Sidebar.Plan',
      exact: false,
    },
  ];

  protected readonly settingsSidebarEntry = {
    route: '/master-data',
    icon: 'settings',
    label: 'Sidebar.Settings',
    exact: false,
  };

  constructor(
    private coreService: CoreService,
    private platform: Platform,
    protected dokaTranslation: DokaI18NextService,
    @Inject(I18NextService) private i18next: ITranslationService,
    @Inject(UsersClient) protected usersClient: UsersClient,
    @Inject(UserInfoService) protected userInfoService: UserInfoService,
    protected loginService: DokaIdentityLoginService,
    protected platformService: PlatformService,
    private filterService: FilterService,
    private router: Router,
  ) {
    this.initializeApp();
  }

  private readonly updateSidebarEntriesOnRoleChange = effect(() => {
    this.userInfoService.currentUser(); // Track changes to the current user to update the sidebar entries accordingly

    if (this.userInfoService.isSuperAdmin()) {
      if (!this.sidebarEntries.includes(this.settingsSidebarEntry)) {
        this.sidebarEntries.push(this.settingsSidebarEntry);
      }
    } else {
      const index = this.sidebarEntries.indexOf(this.settingsSidebarEntry);
      if (index > -1) {
        this.sidebarEntries.splice(index, 1);
      }
    }
  });

  async initializeApp() {
    // Supply Client Id if online Translations are available
    /* environment.yardApiUrl */
    /* , authCodeFlowConfig.clientId! */
    await this.filterService.init();
    await this.platform.ready();

    // required for devices with touch screen to prevent mobile styles
    this.platformService.overridePlatform(PlatformType.Web);
  }

  protected navigateToMasterData() {
    this.router.navigate(['master-data', 'catalog']);
  }
}
